import {ModuleWithProviders, NgModule} from '@angular/core';
import {
  DefaultValidationMessagesComponent,
  FORM_VALIDATOR_CONFIGURATION,
  FormControlValidatorDirective,
  FormGroupValidatorDirective,
  FormValidatorConfig,
  UIFramework,
  ValidatorContainerDirective,
  ValidatorTargetDirective
} from "@core/libs";

export const defaultFormValidationConfig: FormValidatorConfig = {
  skipValidate: false,
  uiFrameWork: UIFramework.Auto,
  unknownErrorValidationMessage: '[This field is invalid]',
  validationMessages: {
    required: 'common.requiredField',
    invalid: 'common.messages.invalidData',
    email: 'common.invalidEmail',
    max: 'common.validator.max',
    maxlength: 'common.validator.maxlength',
    min: 'common.validator.min',
    minlength: 'common.validator.minlength',
    pattern: 'common.validator.pattern',
    range: 'common.validator.range',
    url: 'common.invalidUrl',
    ngbDate: 'common.messages.invalidDate',
  },
  validationMessagesComponent: DefaultValidationMessagesComponent,
  validateOn: ({dirty, touched, submited}) => {
    return (dirty && touched) || submited;
  },
}

@NgModule({
  imports: [
    DefaultValidationMessagesComponent
  ],
  declarations: [
    // DefaultValidationMessagesComponent,
    FormControlValidatorDirective,
    FormGroupValidatorDirective,
    ValidatorContainerDirective,
    ValidatorTargetDirective,
  ],
  providers: [
    {
      provide: FORM_VALIDATOR_CONFIGURATION,
      useValue: defaultFormValidationConfig
    }
  ],
  exports: [
    FormControlValidatorDirective,
    FormGroupValidatorDirective,
    ValidatorContainerDirective,
    ValidatorTargetDirective,
  ],
})
export class FormValidatorModule {
  static configure(config: Partial<FormValidatorConfig>): ModuleWithProviders<FormValidatorModule> {
    const formValidationConfig = {...defaultFormValidationConfig, ...config};
    return {
      ngModule: FormValidatorModule,
      providers: [
        {
          provide: FORM_VALIDATOR_CONFIGURATION,
          useValue: formValidationConfig
        }
      ],
    };
  }
}

const formValidatorConfig: Partial<FormValidatorConfig> = {
  validateOn: (status) => {
    return status.touched || status.submited;
  }
}


export const FormValidateDeclaration = FormValidatorModule.configure(formValidatorConfig);
